import React from "react";
import { Link } from "react-router-dom";
function Footer() {
  const phoneNumber = "8487892218";
  const message = "Hello! I want to chat with you.";

  const handleClick = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const url = isMobile
      ? `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(
          message
        )}`
      : `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
    console.log("click");
  };
  return (
    <>
     
  <div className="rs-footer-area rs-footer-two has-space">
     <div
            className="rs-footer-bg-thumb has-bg-none"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/img_footer_bg_1.jpg)`,
            }}
          ></div>
    <div className="rs-footer-top">
      <div className="container">
        
    
        <div className="row mb-35"> 
          <div className="col-12">
            <div className="rs-footer-widget rs-footer-widget-res">
              <div className="rs-footer-widget-logo">
                <Link to="/">
                  <img 
                    src="/assets/images/pristing-precision-tool-footer-logo.png" 
                    alt="logo" 
                    className="footer-logo"
                   
                    style={{ height: "80px", width: "auto", maxWidth: "100%" }} 
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

       
        <div className="row g-4">
          
          {/* --- Column 1: Useful Links --- */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="rs-footer-widget footer-2-col-2">
              <h5 className="rs-footer-widget-title">Useful Links</h5>
              <div className="rs-footer-widget-content">
                <div className="rs-footer-widget-links has-theme-red">
                  <ul>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/product">Product</Link></li>
                    <li><Link to="/certificate">Certificate</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* --- Column 2: Our Product --- */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="rs-footer-widget rs-footer-widget-res footer-2-col-2">
              <h5 className="rs-footer-widget-title">Our Product</h5>
              <div className="rs-footer-widget-content">
                <div className="rs-footer-widget-links has-theme-red">
                  <ul>
                    <li><Link to="/high-performance-drills">High Performance Drills</Link></li>
                    <li><Link to="/high-performance-endmills">High Performance EndMills</Link></li>
                    <li><Link to="/chamfer-tools">Chamfer Tools</Link></li>
                    <li><Link to="/customized-tools">Customized Tools</Link></li>
                    <li><Link to="/ballnose-endmills">Ballnose EndMills</Link></li>
                    <li><Link to="/product/reamer">Reamer</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* --- Column 3: Email & Address --- */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="rs-footer-widget footer-2-col-3">
              <div className="rs-footer-widget-content">
                <div className="rs-footer-widget-meta">
                  
                  <h5 className="rs-footer-widget-title">Email Address</h5>
                  <div className="rs-footer-widget-email mb-3">
                    <Link to={`mailto:${process.env.REACT_APP_EMAIL2}`}>
                      {process.env.REACT_APP_EMAIL2}
                    </Link>
                  </div>

                  <div className="address-wrap">
                    <h5 className="rs-footer-widget-title">Office Address</h5>
                    <div className="rs-footer-widget-address">
                      <Link target="_blank" to="https://www.google.com/maps">
                        {process.env.REACT_APP_FOOTER_ADDRESS}
                      </Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* --- Column 4: Phone & Social --- */}
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div className="rs-footer-widget footer-2-col-4">
              <h5 className="rs-footer-widget-title">Phone Number</h5>
              <div className="rs-footer-widget-content">
                <div className="rs-footer-widget-contact-info">
                  <div className="rs-footer-widget-number mb-3">
                    <span className="d-block">
                      <Link to={`tel:${process.env.REACT_APP_PHONE1}`}>
                        {process.env.REACT_APP_PHONE1}
                      </Link>
                    </span>
                    <span className="d-block">
                      <Link to={`tel:${process.env.REACT_APP_PHONE2}`}>
                        {process.env.REACT_APP_PHONE2}
                      </Link>
                    </span>
                  </div>
                  
                  <h5 className="rs-footer-widget-title">Follow Us</h5>
                  <div className="rs-footer-widget-social">
                    <div className="rs-theme-social has-theme-red">
                      <Link to="https://www.linkedin.com/company/pristine-precision-tools/" title="LinkedIn"><i className="ri-linkedin-fill"></i></Link>
                      <Link to="https://www.instagram.com/pristinetools.in?igsh=c3lodWg2dXZzc3V4" title="Instagram"><i className="ri-instagram-line"></i></Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div> 
        {/* End of Content Row */}

      </div>
    </div>
    
    {/* Copyright Section (Same as before) */}
    <div className="rs-footer-copyright-area rs-copyright-one">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-12">
            <div className="rs-footer-copyright has-theme-red text-center">
              <p className="underline">
                © <span id="year">{new Date().getFullYear()}</span>{" "}
                {process.env.REACT_APP_COMPANYNAME}. All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


      {/* whatsapp */}
      <div
        className="backtotop-wrap2 cursor-pointer2 has-theme-red2"
        onClick={handleClick}
      >
        <i className="fa-brands fa-whatsapp backtotop-circle2 svg-content2"></i>
      </div>
    </>
  );
}

export default Footer;
